export default "__VITE_ASSET__c$B3NJ3j__"